export const DEFAULT_RULER_SCALE = 10;
export const RULER_SCALE_OPTIONS = Object.freeze([10, 5]);

export function normalizeRulerScale(value) {
  const scale = Number(value);
  return RULER_SCALE_OPTIONS.includes(scale) ? scale : DEFAULT_RULER_SCALE;
}
